import { render, staticRenderFns } from "./SeniorProfile.vue?vue&type=template&id=69fd2e5c&scoped=true&"
import script from "./SeniorProfile.vue?vue&type=script&lang=js&"
export * from "./SeniorProfile.vue?vue&type=script&lang=js&"
import style0 from "./SeniorProfile.vue?vue&type=style&index=0&id=69fd2e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fd2e5c",
  null
  
)

export default component.exports